import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Configure axios interceptors for automatic authentication
import './utils/axiosConfig';

// Auto-reload on chunk load errors (happens after deployment when old chunks are gone)
window.addEventListener('error', (event) => {
  if (event.message && (event.message.includes('ChunkLoadError') || event.message.includes('Loading chunk'))) {
    console.warn('Chunk load failed, reloading for fresh assets...');
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
